export default __webpack_public_path__ + "static/media/green-dust-and-scratches.08e71866.png";